import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

import * as accessors from './accessors';

export const FETCH_GROUP_MEMBERS_REQUEST = 'FETCH_GROUP_MEMBERS_REQUEST';
export const FETCH_GROUP_MEMBERS_SUCCESS = 'FETCH_GROUP_MEMBERS_SUCCESS';
export const FETCH_GROUP_MEMBERS_FAILURE = 'FETCH_GROUP_MEMBERS_FAILURE';

const buildMembersUrl = (groupId) => buildUrl(`/groups/${groupId}/members`);

export const { getMembersByGroup, getMemberById, isLoadingMembers } = accessors;

export function fetchGroupMembersIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildMembersUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchGroupMembers(groupId));
  };
}

export function fetchGroupMembers(groupId) {
  return (dispatch) => {
    const url = buildMembersUrl(groupId);
    const method = 'GET';

    return dispatch(fetchMembersRequest()).payload
      .then((response) => dispatch(fetchMembersSuccess(response)))
      .catch((error) => dispatch(fetchMembersFailure(error)));

    function fetchMembersRequest() {
      return ApiCall.createAction({
        type: FETCH_GROUP_MEMBERS_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchMembersSuccess(members) {
      return ApiCall.createAction({
        type: FETCH_GROUP_MEMBERS_SUCCESS,
        payload: members,
        url,
        method,
        groupId,
      });
    }

    function fetchMembersFailure(error) {
      return ApiCall.createAction({
        type: FETCH_GROUP_MEMBERS_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/GroupMembers/actions.js